import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react'
import { Modal, Tabs, Form, Row, Col, Input, Select, Empty } from 'antd'
import { orderThreeGuaranteesDetail } from '@/service/ordersService'
import TopSearch from '@/components/TopSearch'
import ListComponent from '@/components/listComponent'
import { getPcodeDict } from '@/utils/dataStorage'
const { TabPane } = Tabs
const { Option } = Select
export default (props) => {
    const { t } = useTranslation();
    const { visible, setVisible, id } = props
    const [factoryVal, setFactoryVal] = useState([])
    const [form] = Form.useForm()
    const [formF] = Form.useForm()
    useEffect(() => {
        if (visible) loadData()
    }, [visible]) // eslint-disable-line react-hooks/exhaustive-deps

    //列表数据
    const loadData = (current, search = {}) => {
        orderThreeGuaranteesDetail(id).then((res) => {
            console.log(res)
            let results = res.retData
            form.setFieldsValue({
                ...results,
            })
            const { factoryThreeGuaranteesInfo } = results

            let factoryInfo = []
            if (factoryThreeGuaranteesInfo) {
                const { claimNumber, valList } = factoryThreeGuaranteesInfo
                factoryInfo.push({
                    titleName: t(`ordersManage.sanbaoBill.detail.索赔单号`),
                    val: claimNumber,
                    componentSort: -1
                })
                valList.forEach((item) => {
                    const { titleName, val, componentSort } = item
                    factoryInfo.push({
                        titleName,
                        val,
                        componentSort
                    })
                })
            }
            setFactoryVal(factoryInfo.sort((a, b) => a.componentSort-b.componentSort))

            // const { list, total } = res.retData
            // setpagination({
            //     current: current,
            //     total: total,
            //     pageSize: 10,
            // })
            // let listData = []
            // let columsData = []
            // list.forEach((item, index) => {
            //     const { orderId, orderCode, valList } = item
            //     let newI = {
            //         orderCode,
            //         orderId,
            //     }
            //     valList.forEach((i) => {
            //         newI[i.titleCode] = i.val
            //         if (index === 0) {
            //             columsData.push({
            //                 title: i.titleName,
            //                 align: 'center',
            //                 dataIndex: i.titleCode,
            //                 sort: i.componentSort,
            //             })
            //         }
            //     })
            //     listData.push(newI)
            // })
            // setList(listData)
            // columsData = columsData.sort((a, b) => a.sort - b.sort)
            // columsData.length > 0 && columsData.push({
            //     title: '状态',
            //     align: 'center',
            //     dataIndex: 'orderCode',
            //     render: (text) => <>{text ? <span style={{ color: 'blue' }}>已匹配</span> : <span>未匹配</span>}</>,
            // })
            // setColums(columsData)
        })
    }

    const formItemLayout = {
        labelCol: {
            offset: 2,
        },
        wrapperCol: {
            offset: 2,
        },
    }

    return (
        <>
            <Modal
                forceRender
                visible={visible}
                title= {t(`ordersManage.sanbaoBill.detail.三包详情`)}
                onCancel={() => {
                    setVisible(false)
                }}
                centered={true}
                footer={[]}
                width={1200}
                zIndex={1000}
            >
                <div style={{ height: '600px', overflowY: 'scroll' }}>
                    <Tabs defaultActiveKey="1">
                        <TabPane tab= {t(`ordersManage.sanbaoBill.detail.机构自提`)} key="1">
                            <Form  layout="vertical" form={form} {...formItemLayout}>
                                <Row>
                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.三包品牌`)} name="threeGuaranteesBrand">
                                            <Select placeholder= {t(`ordersManage.sanbaoBill.detail.三包品牌`)} style={{ width: '100%' }} disabled>
                                                {getPcodeDict('106').children.map((item) => (
                                                    <Option value={item.dictCode} key={item.id}>
                                                        {item.title}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.所属实体`)} name="ciBusinessEntityName">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.所属实体`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.索赔单号`)} name="claimNumber">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.可自动生成索赔单号`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.结算单号`)} name="statementNumber">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.结算单号`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.材料费`)} name="materialAmount">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.材料费`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.工时费`)} name="hourlyWage">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.工时费`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.外出费`)} name="travelExpenses">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.外出费`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.餐补费`)} name="mealSupplement">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.餐补费`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.其他费用`)} name="otherAmount">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.其他费用`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.出库金额`)} name="outboundAmount">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.出库金额`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.索赔总额`)} name="totalClaim">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.索赔总额`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.故障处理`)} name="faultHandle">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.故障处理`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.工时费汇总`)} name="totalHourlyWage">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.三包工时费汇总`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.维修时间`)} name="repairTime">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.维修时间`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.维修人员`)} name="maintenanceStaff">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.维修人员`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item label= {t(`ordersManage.sanbaoBill.detail.工时定额`)} name="workHour">
                                            <Input placeholder= {t(`ordersManage.sanbaoBill.detail.工时定额`)} disabled />
                                        </Form.Item>
                                    </Col>

                                    <Form.Item label="" name="ciBusinessEntityName" hidden>
                                        <Input placeholder="" disabled />
                                    </Form.Item>
                                </Row>
                            </Form>
                        </TabPane>
                        <TabPane tab= {t(`ordersManage.sanbaoBill.detail.厂家提报`)} key="2">
                            {factoryVal.length > 0 ? (
                                <Form  layout="vertical" {...formItemLayout}>
                                    <Row>
                                        {factoryVal.map((item) => (
                                            <Col span={6}>
                                                <Form.Item label={item.titleName}>
                                                    <Input placeholder={item.titleName} disabled value={item.val} />
                                                </Form.Item>
                                            </Col>
                                        ))}
                                    </Row>
                                </Form>
                            ) : (
                                <Empty />
                            )}
                        </TabPane>
                    </Tabs>
                </div>
            </Modal>
        </>
    )
}
